import { AppState } from '@store/state';
import { FlightChangeFlagModel } from '@store/changed-flight-state/changed-flight-state.model';
import { Inject, Injectable } from '@angular/core';
import { SearchDataModel } from '@store/search-data/search-data.model';
import { SessionStorageDataModel, SessionStorageService } from '../session-storage/session-storage.service';
import { Store } from '@ngrx/store';
import * as ChangeFlightStateActions from '@store/changed-flight-state/changed-flight-state.actions';
import * as searchDataActions from '@store/search-data/search-data.actions';
import * as selectedOrderActions from '@store/selected-order/selected-order.actions';
import { SelectedOrderModel } from '@store/selected-order/selected-order.model';

@Injectable({
  providedIn: 'root',
})
export class StateService {
  constructor(
    @Inject(Store) private _store: Store<AppState>,
    @Inject(SessionStorageService) private _sessionStorage: SessionStorageService
  ) { }

  getSavedData(): void {
    const savedState: SessionStorageDataModel = this._sessionStorage.storage.SESSION_STORAGE;

    if (savedState && savedState.searchData) {
      this._store.dispatch(searchDataActions.setSearchData({ data: savedState.searchData } as SearchDataModel));
    }

    if (savedState && savedState.wasFlightChangeConfirmed) {
      this._store.dispatch(
        ChangeFlightStateActions.setChangedFlightFlagState({
          wasFlightChangeConfirmed: savedState.wasFlightChangeConfirmed,
        } as FlightChangeFlagModel)
      );
    }

    if (savedState && savedState.selectedOrderData) {
      this._store.dispatch(selectedOrderActions.setSelectedOrderData({ dossierNumber: savedState.selectedOrderData } as SelectedOrderModel));
    }
  }
}
